import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { usePermanentRealTimeUser } from "hooks";
import { createFormHelper } from "lib/Form";
import { ROLES } from "models";
import { countryDropdownOptions } from "utils/common";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

type GeneralProps = {
  tabId: string;
};

export const General = ({ tabId }: GeneralProps) => {
  const { t } = useTranslation();
  const { watch, formState } = FormHelper.useFormContext();

  const { user } = usePermanentRealTimeUser();
  const name = watch("name");

  return (
    <Element name={tabId} className="dealer-overview-section">
      <div className="section-title">
        <div>
          <Icon className="gears" />
        </div>
        <span className="section-title-text">{t("v8_general", "General")}</span>
      </div>
      <div className="dealer-overview-subheading">{t("v8_dealer_info", "Dealer Info")}</div>

      <Form.Group>
        <Form.Field width={8} required error={formState.isSubmitted && !name} disabled={!user || user.role_id > ROLES.SupportAdmin}>
          <label>{t("v8_company_name", "Company name")}</label>
          <FormHelper.Field.Input name="name" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_region", "Region")}</label>
          <FormHelper.Field.Input name="region" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_city", "City")}</label>
          <FormHelper.Field.Input name="city" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_land", "Land")}</label>
          <FormHelper.Field.Dropdown name="country_code" options={countryDropdownOptions} dropdownProps={{ search: true }} />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_street", "Street")}</label>
          <FormHelper.Field.Input name="street" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_postal_code", "Postal code")}</label>
          <FormHelper.Field.Input name="postal_code" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_phone", "Phone")}</label>
          <FormHelper.Field.Input name="phone_nr" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_website_url", "Website URL")}</label>
          <FormHelper.Field.Input name="website_url" />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
